import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { SignatureService } from 'src/app/services/signature.service';
import { LoginService } from 'src/app/services/login.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { PlanSelectionModalComponent } from './modals/plan-selection-modal/plan-selection-modal.component';
import { DateBrasilia } from 'src/app/util/date-brasilia.helper';

type AdminAccountRow = {
  accountId: number;
  accountName: string;
  planName: string;
  status: string;
  startedAt: string | null;
  finishedAt: string | null;
};

@Component({
  selector: 'app-administrative-accounts-list',
  templateUrl: './administrative-accounts-list.component.html',
  styleUrls: ['./administrative-accounts-list.component.scss'],
})
export class AdministrativeAccountsListComponent implements OnInit {
  dateFormat = DateBrasilia;

  loading = false;
  dataSource: MatTableDataSource<AdminAccountRow> = new MatTableDataSource([]);
  displayedColumns: string[] = [
    'account',
    'plan',
    'status',
    'startedAt',
    'finishedAt',
    'gateway',
    'action',
  ];

  total = 0;
  pageIndex = 0;
  pageSize = 10;

  filters: FormGroup;
  statusType: Array<{ label: string; value: string | null }> = [
    { label: 'Todos', value: null },
    { label: 'Atrasada', value: 'Atrasada' },
    { label: 'Ativa', value: 'Ativa' },
    { label: 'Cancelada', value: 'Cancelada' },
    { label: 'Expirada', value: 'Expirada' },
    { label: 'Experimental', value: 'Experimental' },
    { label: 'Experimental Cancelada', value: 'Experimental Cancelada' },
    { label: 'Inativa', value: 'Inativa' },
    { label: 'Iniciada', value: 'Iniciada' },
    { label: 'Sem Assinatura', value: 'Sem Assinatura' },
  ];

  constructor(
    private readonly signatureService: SignatureService,
    private readonly loginService: LoginService,
    private readonly fb: FormBuilder,
    private readonly dialog: MatDialog
  ) {
    this.filters = this.fb.group({
      status: [null],
      accountName: [''],
      accountEmail: [''],
      fromFinishedAt: [''],
      toFinishedAt: [''],
      gateway: [''],
    });
  }

  ngOnInit(): void {
    this.onSearch();
  }

  onSearch(event?: PageEvent): void {
    this.loading = true;

    if (event) {
      this.pageIndex = event.pageIndex;
      this.pageSize = event.pageSize;
    } else {
      this.pageIndex = 0;
    }

    const filterRawValues = this.filters.getRawValue();

    const filter: {
      status?: string;
      accountName?: string;
      accountEmail?: string;
      fromFinishedAt?: string;
      toFinishedAt?: string;
      gateway?: string;
    } = {};
    if (filterRawValues.status) {
      filter.status = filterRawValues.status;
    }
    if (filterRawValues.accountName) {
      filter.accountName = filterRawValues.accountName;
    }
    if (filterRawValues.accountEmail) {
      filter.accountEmail = filterRawValues.accountEmail;
    }
    if (filterRawValues.fromFinishedAt) {
      filter.fromFinishedAt = filterRawValues.fromFinishedAt;
    }
    if (filterRawValues.toFinishedAt) {
      filter.toFinishedAt = filterRawValues.toFinishedAt;
    }
    if (filterRawValues.gateway) {
      filter.gateway = filterRawValues.gateway;
    }

    this.signatureService
      .getAdministrativeAccountsWithPlanV2({
        filter,
        page: this.pageIndex + 1,
        perPage: this.pageSize,
      })
      .subscribe(
        (datatable) => {
          console.log(datatable);

          this.dataSource.data = datatable.rows || [];
          this.total = datatable.total || 0;
          this.loading = false;
        },
        () => {
          this.loginService.showMessage('Erro ao carregar contas');
          this.loading = false;
        }
      );
  }

  clearFilter(): void {
    this.filters.setValue({
      status: null,
      accountName: '',
      accountEmail: '',
      fromFinishedAt: '',
      toFinishedAt: '',
      gateway: '',
    });
    this.onSearch();
  }

  onChangeStatusFilter(): void {
    this.onSearch();
  }

  applyFilter(): void {
    this.onSearch();
  }

  gatewayLinkGenerate(contactId: string): { link: string; label: string } {
    if (!contactId) {
      return { label: '-', link: '' }; // sem link
    }

    return contactId.startsWith('IUGU')
      ? {
          label: 'IUGU',
          link: `https://alia.iugu.com/contact/customers/${contactId.slice(
            5,
            contactId.length
          )}`,
        }
      : {
          label: 'GURU',
          link: `https://digitalmanager.guru/admin/contacts/${contactId}`,
        };
  }

  openPlanModal(row: AdminAccountRow): void {
    this.dialog.open(PlanSelectionModalComponent, {
      width: '520px',
      data: {
        accountId: row.accountId,
        accountName: row.accountName,
        status: row.status,
      },
      disableClose: true,
    });
  }
}
